import JsEval from "../../modules/utils/utils-js/theme/js/JsEval";
import Form from "../../modules/core/forms/theme/js/Form";
import SVGInject from "../../modules/media/svg/theme/js/SVGInject";
import Utils from "../../modules/utils/utils-js/theme/js/utils/Utils";

declare var WOW;

class Site {
    public static SLICK_PREV = '<button type="button" class="slick-arrow-button slick-prev"><i class="fa fa-arrow-left"></i></button>';
    public static SLICK_NEXT = '<button type="button" class="slick-arrow-button slick-next"><i class="fa fa-arrow-right"></i></button>';

    public static initWcag(): void {
        const $html = $('html');
        const $body = $('body');

        const $zoomplus = $('.wcagmenu__zoom--plus');
        const $zoomminus = $('.wcagmenu__zoom--minus');
        const $contrast = $('.wcagmenu__contrast');

        let wcagzoom = parseInt(window.localStorage.getItem('wcag-zoom'));
        let wcagcontrast = parseInt(window.localStorage.getItem('wcag-contrast'));

        wcagzoom = isNaN(wcagzoom) ? null : wcagzoom;
        wcagcontrast = isNaN(wcagcontrast) ? null : wcagcontrast;

        const setZoom = (ix: number) => {
            const $cl = $('.content__left');
            $html.removeClass('wcag-zoom wcag-zoom--1 wcag-zoom--2 wcag-zoom--3');
            $cl.removeClass('z1 z2 z3');

            if (ix != null) {
                $html.addClass('wcag-zoom wcag-zoom--' + (ix + 1));
                $cl.addClass('z' + (ix + 1));
            }

            $html.toggleClass('wcag', $html.hasClass('wcag-zoom') || $html.hasClass('wcag-contrast'));

            wcagzoom = ix;

            $(window).resize();
        };

        const setContrast = (ix: number) => {
            $html.removeClass('highcontrast wcag-contrast wcag-contrast--1 wcag-contrast--2 wcag-contrast--3');
            $body.removeClass('highcontrast');

            if (ix != null) {
                $html.addClass('wcag-contrast wcag-contrast--' + (ix));
                $body.addClass('highcontrast');
            }

            $html.toggleClass('wcag', $html.hasClass('wcag-zoom') || $html.hasClass('wcag-contrast'));

            wcagcontrast = ix;

            $(window).resize();
        };

        $contrast.on('click', function (e) {
            e.preventDefault();

            let ix = (wcagcontrast + 1) % 3;

            if (ix == 0) {
                ix = null;
                window.localStorage.removeItem('wcag-contrast');
            } else {
                window.localStorage.setItem('wcag-contrast', ix.toString());
            }

            setContrast(ix);
        });

        const doZoom = (zoom: number): void => {
            if (zoom < 0) {
                zoom = 0;
            } else if (zoom > 2) {
                zoom = 2;
            }

            if (zoom == 0) {
                zoom = null;
                window.localStorage.removeItem('wcag-zoom');
            } else {
                window.localStorage.setItem('wcag-zoom', zoom.toString());
            }

            setZoom(zoom);
        }

        $zoomminus.on('click', function (e) {
            e.preventDefault();
            doZoom(wcagzoom - 1);
        });

        $zoomplus.on('click', function (e) {
            e.preventDefault();
            doZoom(wcagzoom + 1);
        });

        setZoom(wcagzoom);
        setContrast(wcagcontrast);

        $(window).on('keyup', (e) => {
            const $target = $(e.target);

            switch (e.key) {
                case 'Escape':
                    $('.search-box input').blur();
                    break;
            }

            if ($target.is(':input')) {
                return;
            }

            if (!e.ctrlKey && !e.altKey && !e.shiftKey) {
                switch (e.key) {
                    case '/':
                        $('.search-box input').focus();
                        break;

                    case 'c':
                    case 'C':
                        $contrast.click();
                        break;

                    case 'z':
                    case 'Z':
                        $zoomplus.click();
                        break;

                    case 'x':
                    case 'X':
                        $zoomminus.click();
                        break;
                }
            }
        });
    }

    public static onGallerySlider($uid: JQuery): void {
        const $slider = $('.galleryslider__slider', $uid);
        const $items = $('.galleryslider__item', $uid);;

        (<any> $slider).slick({
            slidesToShow: 4,
            arrows: true,
            infinite: true,
            accessibility: false,

            prevArrow: this.SLICK_PREV,
            nextArrow: this.SLICK_NEXT,

            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                    breakpoint: 720,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 490,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        let bypass = 0;

        $items.on('mousedown', (e) => {
            bypass = 1;
        });

        $items.on('mousemove', (e) => {
            bypass = 2;
        });

        $items.each((ix, el) => {
            const $el = $(el);

            $el.on('click', (e) => {
                e.preventDefault();

                if (bypass != 2) {
                    (<any> $).fancybox({
                        type: 'image',
                        href: $el.prop('href'),
                        title: $el.prop('title'),
                    });
                }

                bypass = 0;
            });
        });
    }

    public static discover($parent?: JQuery): void {
    }

    public static onVideo1($uid: JQuery): void {
        const $video = $('video', $uid);
        const video = <HTMLVideoElement> $video[0];
        const $mute = $('.video1__mute', $uid);
        const $mutei = $('i', $mute);

        $mute.on('click', (e) => {
            video.muted = !video.muted;

            if (video.muted) {
                $mutei.addClass('fa fa-volume-mute');
            } else {
                $mutei.addClass('fa fa-volume-down');
            }
        });
    }

    public static onSlider1($uid: JQuery): void {
        const $_slick = (<any> $uid);

        $_slick.slick({
            arrows: false,
            dots: true,
            infinite: true,

            slidesToShow: 1,
        });
    }

    private static updateFloat() {
        const wx = window.innerWidth;

        const $body = $('body');
        const $mainmenu = $('.mainmenu');
        const $menu = $('.menu--main');
        const top = $(window).scrollTop();

        const mobile = 768;

        $mainmenu.toggleClass('mainmenu--mobile', wx <= mobile);
        $mainmenu.toggleClass('mainmenu--full', wx > mobile);

        $menu.toggleClass('menu--mobile', wx <= mobile);
        $menu.toggleClass('menu--full', wx > mobile);

        $body.toggleClass('body--float', top > 0);
        $body.toggleClass('body--no-float', top == 0);
    }

    private static initMenus(): void {
        var $mainmenu=$('.mainmenu');

        $('.mainmenu__button', $mainmenu).click(function(e) {
            e.preventDefault();

            $mainmenu.toggleClass('mainmenu--opened', !$mainmenu.hasClass('mainmenu--opened'))
        });

        $mainmenu.addClass('mainmenu--inited');
    }

    private static initHtml() {
        this.initWcag();
        this.initMenus();
        this.discover();

        if (!$('html').hasClass('wcag-contrast')) {
            new WOW().init();
        }

        $(window).on('resize scroll', Site.updateFloat);
        $(window).trigger('resize');
    }

    /**
     * @override
     */
    public static init(): void {
        (<any> window).Site = Site;

        Form.init();
        SVGInject.init();
        Utils.init();

        $(() => {
            Site.initHtml();
        });

        $(window).on('load', () => {
            $('body').addClass('body--loaded');

            setTimeout(() => {
                $('body').removeClass('body--loading');
                $('body').addClass('body--loaded2');
                $('body').trigger('pageloaded');
            }, 1000);
        });

        JsEval.eval();
    }
}

Site.init();
